import { Controller } from 'stimulus';

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.css'

export default class extends Controller {
    static targets = ['form'];

    submitForm(event) {
        let msg = this.formTarget.getAttribute('data-message')
        this.formTarget.querySelector('input[name="commit"]').blur()
        if(msg){
            event.preventDefault()
            let self = this
            Swal.fire({
                title: msg,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
            }).then(result => self.confirmed(result))
        }
    }

    confirmed(result){
        if(result.value){
            let msg2 = this.formTarget.getAttribute('data-message2')
            if(msg2){
                let self = this
                Swal.fire({
                    title: msg2,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                }).then(result2 => self.confirmed2(result2))
            } else {
                this.formTarget.removeAttribute('data-message')
                this.formTarget.submit()
            }
        } else {
            this.formTarget.querySelector('input[name="commit"]').removeAttribute('disabled')
        }
    }

    confirmed2(result){
        if(result.value){
            this.formTarget.removeAttribute('data-message')
            this.formTarget.removeAttribute('data-message2')
            this.formTarget.submit()
        } else {
            this.formTarget.querySelector('input[name="commit"]').removeAttribute('disabled')
        }
    }

}
